import {
  Component,
  Input,
  OnInit,
  SimpleChange,
  SimpleChanges,
} from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../../../services/api.service';
import { Product } from '../../../models/product';
import { EventEmitter } from 'events';
import { findReadVarNames } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'alg-progress-mobile',
  templateUrl: './alg-progress-mobile.component.html',
  styleUrls: ['./alg-progress-mobile.component.scss'],
})
export class AlgProgressMobileComponent implements OnInit {
  public currentOnBoarding: any;
  public websiteUrl: string = environment.websiteUrl;
  public product: Product = {} as Product;
  public isProductPlacet: boolean;

  @Input() switchStatus: string;

  constructor(private api: ApiService) {}

  public progresses = {
    init: 0,
    document: 0,
    user_info: 1,
    contract_info: 2,
    supplies: 3,
    payment: 4,
    insurance: 5,
    summary: 6,
  };

  public progressesPlacet = {
    init: 0,
    document: 0,
    user_info: 1,
    contract_info: 2,
    supplies: 3,
    payment: 4,
    summary: 5,
  };

  public progressesMin = {
    init: '',
    document: '',
    user_info: '2 minuti',
    contract_info: '4 minuti',
    supplies: '2 minuti',
    payment: '2 minuti',
    insurance: '2 minuti',
    summary: '30 sec',
  };

  public progressesMinPlacet = {
    init: '',
    document: '',
    user_info: '2 minuti',
    contract_info: '4 minuti',
    supplies: '2 minuti',
    payment: '2 minuti',
    summary: '30 sec',
  };

  public progressesTitle = {
    init: 'Documenti Necessari',
    document: 'Documenti Necessari',
    user_info: 'Titolare della fornitura',
    contract_info: 'Dati contrattuali',
    supplies: 'La tua fornitura',
    payment: 'Pagamento',
    insurance: 'Opzioni Aggiuntive',
    summary: 'Riepilogo',
  };

  public progressesTitlePlacet = {
    init: 'Documenti Necessari',
    document: 'Documenti Necessari',
    user_info: 'Titolare della fornitura',
    contract_info: 'Dati contrattuali',
    supplies: 'La tua fornitura',
    payment: 'Pagamento',
    summary: 'Riepilogo',
  };

  public progressesNextTitle = {
    init: 'Titolare della fornitura',
    document: 'Titolare della fornitura',
    user_info: 'Dati contrattuali',
    contract_info: 'La tua fornitura',
    supplies: 'Pagamento',
    payment: 'Opzioni Aggiuntive',
    insurance: 'Riepilogo',
    summary: 'Done',
  };

  public progressesNextTitlePlacet = {
    init: 'Titolare della fornitura',
    document: 'Titolare della fornitura',
    user_info: 'Dati contrattuali',
    contract_info: 'La tua fornitura',
    supplies: 'Pagamento',
    payment: 'Riepilogo',
    summary: 'Done',
  };

  public progress = 0;
  public progressMin = '';
  public progressTitle = '';
  public progressNextTitle = '';

  ngOnInit() {
    this.api.currentOnboarding
      .combineLatest(this.api.currentProduct)
      .subscribe(([currentOnBoarding, product]) => {
        this.currentOnBoarding = currentOnBoarding;
        this.product = product;

        if (
          this.product &&
          !!this.product.family &&
          this.product.family.name === 'Placet'
        ) {
          this.isProductPlacet = true;
        }

        this.progress = this.isProductPlacet
          ? this.progressesPlacet[currentOnBoarding.webStatus]
          : this.progresses[currentOnBoarding.webStatus];
        this.progressMin = this.isProductPlacet
          ? this.progressesMinPlacet[currentOnBoarding.webStatus]
          : this.progressesMin[currentOnBoarding.webStatus];
        this.progressTitle = this.isProductPlacet
          ? this.progressesTitlePlacet[currentOnBoarding.webStatus]
          : this.progressesTitle[currentOnBoarding.webStatus];
        this.progressNextTitle = this.isProductPlacet
          ? this.progressesNextTitlePlacet[currentOnBoarding.webStatus]
          : this.progressesNextTitle[currentOnBoarding.webStatus];
      });
  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngOnChanges(changes: SimpleChanges) {
    this.findNameStatus(this.switchStatus);
  }

  findNameStatus(status) {
    this.progressTitle = this.progressesTitle[status];
    this.progress = this.progresses[status];
    this.progressMin = this.progressesMin[status];
    this.progressNextTitle = this.progressesNextTitle[status];
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-progress-mobile/alg-progress-mobile.component.ts